import { render, staticRenderFns } from "./feesAndPoints.vue?vue&type=template&id=616850cb&scoped=true&"
import script from "./feesAndPoints.vue?vue&type=script&lang=js&"
export * from "./feesAndPoints.vue?vue&type=script&lang=js&"
import style0 from "./feesAndPoints.vue?vue&type=style&index=0&id=616850cb&lang=scss&scoped=true&"
import style1 from "./feesAndPoints.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "616850cb",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCheckbox,VDatePicker,VIcon,VMenu,VSelect,VTextField})
